export default [
  {
    value: 10,
    label: 'SuperAdmin'
  },
  {
    value: 5,
    label: 'DeviceAdmin'
  },
  {
    value: 4,
    label: 'KeyAdmin'
  },
  {
    value: 3,
    label: 'Keeper'
  },
  {
    value: 2,
    label: 'PowerUser'
  },
  {
    value: 1,
    label: 'User'
  }
]



// WEBPACK FOOTER //
// ./src/components/access/userLevels.js